import { createFileRoute } from '@tanstack/react-router'

import { GlobalRoleType } from '@beaded/models'

import { requireGlobalRole } from 'lib/routeGuards'

import Devices from 'pages/Devices'

export const Route = createFileRoute('/_auth/_global/devices')({
  beforeLoad: requireGlobalRole(
    GlobalRoleType.GLOBAL_EDIT,
    GlobalRoleType.GLOBAL_ADMIN,
  ),
  component: Devices,
})
